import React, { useRef, useEffect } from 'react'
import { PropsType } from '../../models/util'
import { Toast } from 'primereact/toast'

export interface ToastProps extends PropsType {
    elRef: any
    severity?: string
    summary?: String
    closable?: boolean
    onClose?: () => void
    life?: number
    className?: string
}

export default (props: ToastProps) => {
    return (
        <Toast
            {...props}
            ref={props.elRef}
            position={'bottom-right'}
            className={props.className}
        />
    )
}
